import { StyleSheet, View } from 'react-native';

import type { Vimeo } from '@fhs/cms-groq-queries';
import { tokens } from '@fhs/ui';

import { VimeoEmbed } from './vimeo-embed';

type VimeoBackgroundVideoProps = {
  aspectRatio?: string | number;
  video: Pick<Vimeo, 'id' | 'pictures'>;
  mediaAltText: string;
  loading?: 'eager' | 'lazy';
  width: number;
  height: number;
  hideFromAccessibility?: boolean;
};

export default function VimeoBackgroundVideo({
  aspectRatio = '16 / 9',
  video,
  mediaAltText,
  width,
  height,
  hideFromAccessibility = false,
}: VimeoBackgroundVideoProps) {
  const mediaStyle = {
    aspectRatio,
    minWidth: width,
    minHeight: height,
  } as const;

  return (
    <View style={styles.wrapper}>
      <VimeoEmbed
        video={video}
        mediaAltText={mediaAltText}
        style={mediaStyle}
        hideFromAccessibility={hideFromAccessibility}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    height: '100%',
    backgroundColor: tokens.colors.$houseDark,
    overflow: 'hidden',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
